/* Hug Ease — Build Your Bundle
   Client-side logic for the bundle builder page.
   Reads config from <script id="hugease-bundle-data" type="application/json">.
   On checkout: redirects to /cart/{variants}?discount={code} permalink (no fetch — prevents cart popup) */
(function() {
  'use strict';

  // ─── State ────────────────────────────────────────────
  var data, tiers, products;
  var cart = {}; // variantId -> qty
  var carouselIdx = {}; // productId -> current image index

  // ─── Helpers ──────────────────────────────────────────
  function fmtPrice(cents) {
    return 'A$' + (cents / 100).toFixed(2);
  }
  function totalQty() {
    var t = 0;
    for (var k in cart) t += cart[k];
    return t;
  }
  function totalCents() {
    var t = 0;
    for (var k in cart) {
      var v = findVariant(parseInt(k));
      if (v) t += v.price * cart[k];
    }
    return t;
  }
  function findVariant(vid) {
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      for (var j = 0; j < p.variants.length; j++) {
        if (p.variants[j].id === vid) return p.variants[j];
      }
    }
    return null;
  }
  function findProductByVariant(vid) {
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      for (var j = 0; j < p.variants.length; j++) {
        if (p.variants[j].id === vid) return p;
      }
    }
    return null;
  }
  function currentTierIdx() {
    var qty = totalQty();
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (qty >= tiers[i].min) return i;
    }
    return -1;
  }
  function nextTierIdx() {
    var qty = totalQty();
    for (var i = 0; i < tiers.length; i++) {
      if (qty < tiers[i].min) return i;
    }
    return -1; // already at top tier
  }

  // ─── Render: tier cards ───────────────────────────────
  function renderTiers() {
    var cur = currentTierIdx();
    var nxt = nextTierIdx();
    document.querySelectorAll('#hbTiers .hb__tier').forEach(function(el, idx) {
      el.classList.remove('is-active', 'is-achieved', 'is-next');
      if (idx === cur) el.classList.add('is-active', 'is-achieved');
      else if (idx < cur) el.classList.add('is-achieved');
      else if (idx === nxt) el.classList.add('is-next');
    });
  }

  // ─── Render: progress segments + label ────────────────
  function renderProgress() {
    var qty = totalQty();
    var cur = currentTierIdx();
    var segs = document.querySelectorAll('#hbSegRow .hb__seg');
    var labs = document.querySelectorAll('#hbSegLabels .hb__seg-label');
    segs.forEach(function(s, i) { s.classList.toggle('is-filled', i <= cur); });
    labs.forEach(function(l, i) {
      l.classList.remove('is-unlocked','is-active');
      if (i === cur) l.classList.add('is-active');
      else if (i < cur) l.classList.add('is-unlocked');
    });

    var txt = document.getElementById('hbProgressText');
    if (qty === 0) {
      txt.innerHTML = 'Add a plush to start your bundle';
    } else if (qty === 1) {
      txt.innerHTML = '<strong>1 plush</strong> added &middot; add 1 more for <strong>30% off</strong>';
    } else {
      var t = tiers[cur];
      var nxtIdx = nextTierIdx();
      if (nxtIdx >= 0) {
        var need = tiers[nxtIdx].min - qty;
        txt.innerHTML = '<strong>' + qty + ' plushes</strong> &middot; ' + t.badge_pct + '% off active &middot; add ' + need + ' more for <strong>' + tiers[nxtIdx].badge_pct + '% off</strong>';
      } else {
        txt.innerHTML = '<strong>' + qty + ' plushes</strong> &middot; max discount unlocked &middot; ' + t.badge_pct + '% off';
      }
    }
  }

  // Calculate savings + final price for a given tier
  function calcSavings(tier, origCents) {
    if (!tier) return {savings: 0, final: origCents, badgePct: 0};
    if (tier.discount_type === 'fixed') {
      // Fixed $ off — savings is the fixed amount in CENTS
      var savings = tier.save * 100;
      return {
        savings: savings,
        final: Math.max(0, origCents - savings),
        badgePct: tier.badge_pct
      };
    } else {
      // Percentage
      var savings = Math.round(origCents * tier.pct / 100);
      return {savings: savings, final: origCents - savings, badgePct: tier.badge_pct};
    }
  }

  // ─── Render: sticky bar ───────────────────────────────
  function renderBar() {
    var qty = totalQty();
    var bar = document.getElementById('hbBar');
    var cur = currentTierIdx();
    if (qty === 0) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = 'block';

    var orig = totalCents();
    var tier = cur >= 0 ? tiers[cur] : null;
    var calc = calcSavings(tier, orig);

    document.getElementById('hbBarMsg').textContent = qty + (qty === 1 ? ' plush' : ' plushes') + ' added';
    var origEl = document.getElementById('hbBarOrig');
    var saveEl = document.getElementById('hbBarSave');
    if (calc.savings > 0) {
      origEl.style.display = 'inline';
      saveEl.style.display = 'inline';
      origEl.textContent = fmtPrice(orig);
      saveEl.textContent = 'SAVE ' + fmtPrice(calc.savings) + ' (' + calc.badgePct + '% OFF)';
    } else {
      origEl.style.display = 'none';
      saveEl.style.display = 'none';
    }
    document.getElementById('hbBarTotal').textContent = fmtPrice(calc.final);

    var btn = document.getElementById('hbCheckoutBtn');
    btn.disabled = qty < 2;
    btn.innerHTML = (qty < 2 ? 'Add another to unlock 30% off' : 'Add bundle to cart') +
      ' <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7H11M11 7L7 3M11 7L7 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  // ─── Render: product grid ─────────────────────────────
  function renderGrid() {
    var grid = document.getElementById('hbGrid');
    grid.innerHTML = '';
    products.forEach(function(p) {
      var pQty = 0;
      p.variants.forEach(function(v) { pQty += (cart[v.id] || 0); });

      var card = document.createElement('div');
      card.className = 'hb__card' + (pQty > 0 ? ' has-items' : '');
      card.setAttribute('data-product-id', p.id);

      // Image carousel
      var imgWrap = document.createElement('div');
      imgWrap.className = 'hb__img-wrap';
      imgWrap.innerHTML = '<span class="hb__badge">' + pQty + '</span>';
      var slides = document.createElement('div');
      slides.className = 'hb__slides';
      var imgs = (p.imgs && p.imgs.length) ? p.imgs : [p.img];
      imgs.forEach(function(src) {
        var slide = document.createElement('div');
        slide.className = 'hb__slide';
        var img = document.createElement('img');
        img.src = (src.indexOf('//') === 0 ? 'https:' : '') + src;
        img.alt = p.title;
        img.loading = 'lazy';
        slide.appendChild(img);
        slides.appendChild(slide);
      });
      imgWrap.appendChild(slides);

      // Carousel arrows + dots (only if >1 image)
      if (imgs.length > 1) {
        var prev = document.createElement('button');
        prev.className = 'hb__arr hb__arr--prev';
        prev.setAttribute('aria-label', 'Previous image');
        prev.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.5 3L4.5 6L7.5 9" stroke="#121212" stroke-width="1.6" stroke-linecap="round"/></svg>';
        var next = document.createElement('button');
        next.className = 'hb__arr hb__arr--next';
        next.setAttribute('aria-label', 'Next image');
        next.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 3L7.5 6L4.5 9" stroke="#121212" stroke-width="1.6" stroke-linecap="round"/></svg>';
        prev.addEventListener('click', function(e) { e.preventDefault(); shiftCarousel(p.id, -1, imgs.length); });
        next.addEventListener('click', function(e) { e.preventDefault(); shiftCarousel(p.id, 1, imgs.length); });
        imgWrap.appendChild(prev); imgWrap.appendChild(next);

        var dots = document.createElement('div');
        dots.className = 'hb__dots';
        imgs.forEach(function(_, i) {
          var d = document.createElement('div');
          d.className = 'hb__dot' + (i === 0 ? ' is-active' : '');
          dots.appendChild(d);
        });
        imgWrap.appendChild(dots);
      }
      card.appendChild(imgWrap);

      // Body
      var body = document.createElement('div');
      body.className = 'hb__card-body';
      // Strip "| Breathing Plush" suffix for cleaner display
      var displayTitle = p.title.replace(/\s*\|\s*Breathing Plush.*$/i, '').replace(/\s*\(.*?\)$/, '');
      body.innerHTML =
        '<h3 class="hb__card-name">' + displayTitle + '</h3>' +
        '<div class="hb__card-price">' + fmtPrice(p.price) +
        (p.compare_at_price > p.price ? ' <span class="hb__was">' + fmtPrice(p.compare_at_price) + '</span>' : '') +
        '</div>';

      // Stepper
      var v0 = p.variants[0]; // default to first variant since plushes have 1 variant each
      var stepper = document.createElement('div');
      stepper.className = 'hb__stepper';
      stepper.innerHTML =
        '<button class="hb__step-btn" data-action="dec" aria-label="Decrease"' + (pQty === 0 ? ' disabled' : '') + '>−</button>' +
        '<span class="hb__step-num">' + pQty + '</span>' +
        '<button class="hb__step-btn" data-action="inc" aria-label="Increase">+</button>';
      stepper.querySelector('[data-action="inc"]').addEventListener('click', function(e) {
        e.preventDefault();
        cart[v0.id] = (cart[v0.id] || 0) + 1;
        renderAll();
      });
      stepper.querySelector('[data-action="dec"]').addEventListener('click', function(e) {
        e.preventDefault();
        if (cart[v0.id] && cart[v0.id] > 0) {
          cart[v0.id]--;
          if (cart[v0.id] === 0) delete cart[v0.id];
          renderAll();
        }
      });
      body.appendChild(stepper);
      card.appendChild(body);

      grid.appendChild(card);
    });
  }

  function shiftCarousel(productId, dir, total) {
    var card = document.querySelector('.hb__card[data-product-id="' + productId + '"]');
    if (!card) return;
    var slides = card.querySelector('.hb__slides');
    var dots = card.querySelectorAll('.hb__dot');
    var cur = carouselIdx[productId] || 0;
    cur = (cur + dir + total) % total;
    carouselIdx[productId] = cur;
    slides.style.transform = 'translateX(-' + (cur * 100) + '%)';
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === cur); });
  }

  function renderAll() {
    renderTiers();
    renderProgress();
    renderBar();
    renderGrid();
  }

  // ─── Checkout: redirect to /cart permalink with discount ───
  // (No fetch, no cart events — prevents Shrine cart-drawer / Corner Cart popup from triggering)
  function checkout() {
    var qty = totalQty();
    if (qty < 2) return;
    var cur = currentTierIdx();
    var tier = cur >= 0 ? tiers[cur] : null;

    // Disable button to prevent double-clicks
    var btn = document.getElementById('hbCheckoutBtn');
    btn.disabled = true;
    btn.innerHTML = 'Adding to cart...';

    // Build cart permalink: /cart/123:1,456:2
    var items = [];
    for (var k in cart) {
      items.push({ id: parseInt(k), quantity: cart[k] });
    }
    var cartPath = '/cart/' + items.map(function(i) { return i.id + ':' + i.quantity; }).join(',');
    if (tier && tier.code) cartPath += '?discount=' + tier.code;

    // Full page navigation = no JS cart event = no popup
    window.location.href = cartPath;
  }

  // ─── Init ─────────────────────────────────────────────
  function init() {
    var dataEl = document.getElementById('hugease-bundle-data');
    if (!dataEl) {
      console.warn('hugease-bundle-data not found');
      return;
    }
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Bundle data parse error', e);
      return;
    }
    tiers = data.tiers;
    products = (data.products || []).sort(function(a, b) { return (a.sortOrder || 0) - (b.sortOrder || 0); });
    if (products.length === 0) {
      document.getElementById('hbGrid').innerHTML = '<p style="grid-column:1/-1;text-align:center;color:#999;padding:3rem;">No products in this collection yet.</p>';
      return;
    }
    document.getElementById('hbCheckoutBtn').addEventListener('click', checkout);
    renderAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
